import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SEO } from "../components/SEO";
import { PRODUCTS } from "../data/content";

export default function NotFound() {
  return (
    <>
      <SEO title="Page not found | ZasyaOnline" description="The page you're looking for doesn't exist." path="/404" />
      <section className="flex min-h-[80vh] items-center pt-24 pb-16" data-testid="not-found-page">
        <div className="container-x text-center">
          <p className="font-display text-8xl font-extrabold tracking-tight text-slate-200 sm:text-9xl" aria-hidden="true">
            404
          </p>
          <h1 className="-mt-6 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
            This page took a different route.
          </h1>
          <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-slate-600">
            The page you're looking for doesn't exist or has moved. Here's where
            visitors usually go next:
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-2.5">
            {PRODUCTS.map((p) => (
              <Link
                key={p.id}
                to={p.path}
                className="rounded-full border border-slate-300 bg-white px-4 py-2 text-xs font-semibold text-slate-700 transition-colors hover:border-blue-500 hover:text-blue-700"
                data-testid={`not-found-product-${p.id}`}
              >
                {p.name}
              </Link>
            ))}
          </div>
          <Link to="/" className="btn-primary mt-10" data-testid="not-found-home-link">
            <ArrowLeft size={15} aria-hidden="true" /> Back to home
          </Link>
        </div>
      </section>
    </>
  );
}
